/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { ObservableCollection$1 } from "igniteui-react-core";
import { GridFilterDialogViewModelGrouping } from "./GridFilterDialogViewModelGrouping";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var GridFilterDialogViewModelGroupingLevel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridFilterDialogViewModelGroupingLevel, _super);
    function GridFilterDialogViewModelGroupingLevel() {
        return _super.call(this, GridFilterDialogViewModelGrouping.$, 0) || this;
    }
    GridFilterDialogViewModelGroupingLevel.$t = markType(GridFilterDialogViewModelGroupingLevel, 'GridFilterDialogViewModelGroupingLevel', ObservableCollection$1.$.specialize(GridFilterDialogViewModelGrouping.$));
    return GridFilterDialogViewModelGroupingLevel;
}(ObservableCollection$1));
export { GridFilterDialogViewModelGroupingLevel };
//# sourceMappingURL=GridFilterDialogViewModelGroupingLevel.js.map
